var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"infinite",style:({ height: _vm.height })},[_c('div',{ref:"inner",staticClass:"inner"},[_vm._t("title"),_vm._t("default"),(_vm.loading)?_vm._t("loading"):_vm._e(),(_vm.nomore)?_vm._t("nomore"):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }